// extracted by mini-css-extract-plugin
export default {"locationHourInput":"styles_locationHourInput__WlcLO","taperPresetInput":"styles_taperPresetInput__uWXb2","booleanInput":"styles_booleanInput__EotS7"};